import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  public htmlData: any = {};

  constructor() {
    this.htmlData["year"] = new Date().getFullYear();
  }

}
